import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AuthRepository } from '../../domain/repository';
import { AuthLogoutRequest, AuthLogoutResponse } from '../../domain/dto';

@Injectable({ providedIn: 'root' })
export class LogoutUseCase {
  constructor(private authRepository: AuthRepository) {}

  execute(request: AuthLogoutRequest = {}): Observable<HttpResponse<AuthLogoutResponse>> {
    return this.authRepository.logout(request);
  }
}


